



















import { Component, Vue, namespace } from 'nuxt-property-decorator'
import { Context } from '@nuxt/types'
import { COLLECTIONS_API } from '~/assets/config/api-path'
import { IStyle } from '~/assets/interfaces/classes'
import { COLLECTIONS_PATH } from '~/assets/config/path'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { IMeta } from '~/assets/interfaces/meta'
import { filterUrl } from '~/assets/filters/url'
import ComponentNavigationPagination from '~/components/navigation/pagination.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentIntersect from '~/components/intersect/intersect.vue'
import ComponentArticleItem from '~/components/articles/article-item.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
const pageStore = namespace('page')
@Component({
  watchQuery: ['page'],
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentPageContent,
    ComponentIntersect,
    ComponentArticleItem,
    ComponentTypographyH1,
    ComponentNavigationPagination,
  },
})
export default class pageNews extends Vue {
  private async asyncData({ $axios, route }: Context) {
    const response = await $axios.$get(filterUrl(COLLECTIONS_API), {
      params: route.query,
    })

    return response
  }

  private breadcrumbs: IBreadcrumbsItem[] = [
    {
      title: 'Коллекции',
      url: COLLECTIONS_PATH,
    },
  ]

  private pages = 1

  private styleSpacer!: IStyle
  private $style!: IStyle

  private get classList() {
    return {
      [this.$style.list]: true,
      [this.styleSpacer.mb24]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }

  @pageStore.Mutation('setMeta') private setMeta!: (
    meta: IMeta
  ) => Promise<void>

  private created(): void {
    this.setMeta({
      title: 'Коллекции',
      h1: 'Коллекции',
    })
  }
}
